import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { ClassicPdpUsp } from '../classic-pdp-content';

export interface ProductUspsProps {
  usps: ClassicPdpUsp[];
}

/**
 * Short trust lines under the call to action ("Free shipping", …). The check
 * mark is part of the layout, so the CMS only provides the texts.
 */
export function ProductUsps({ usps }: Readonly<ProductUspsProps>) {
  if (usps.length === 0) {
    return null;
  }

  return (
    <ul data-testid="classic-pdp-usps" className="flex flex-wrap gap-x-6 gap-y-2">
      {usps.map((usp) => (
        <li key={usp.text} className="flex items-center gap-1.5 text-sm font-bold text-[#147E47]">
          <CheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span>{usp.text}</span>
        </li>
      ))}
    </ul>
  );
}
